const NS = 'UniqueTableJoin';

export default function () {
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope, element, attrs, ngModel) {
    var validate = function (viewValue) {
      var tableJoins = JSON.parse(attrs.uniqueTableJoin);
      if (!ngModel.$modelValue || !ngModel.$viewValue || !tableJoins) {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('unique-table-join', true);
      } else {
        var joinedTables = ngModel.$viewValue;
        var valid = true;
        var matchedCount = 0;
        for (var j = tableJoins.length - 1; j >= 0; j--) {
          var tableJoin = tableJoins[j];
          if (tableJoin && tableJoin.tables && tableJoin.tables.length === joinedTables.length) {
            var tableIdsString = tableJoin.tables.join('---');
            var matches = 0;
            for (var i = joinedTables.length - 1; i >= 0; i--) {
              if (tableIdsString.indexOf(joinedTables[i]) !== -1) {
                // table found
                matches++;
              }
            }
            if (matches === joinedTables.length) {
              matchedCount++;
            }
            if (matchedCount > 1) {
              valid = false;
              break;
            }
          }
        }
        ngModel.$setValidity('unique-table-join', valid);
      }
      return viewValue;
    };

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('uniqueTableJoin', function () {
      // Whenever the comparison model changes we'll re-validate
      return validate(ngModel.$viewValue);
    });
  }
}
